import { PitchListHelper } from 'classes/helpers/pitch-list.helper';
import { ErrorBoundary } from 'components/common/error-boundary';
import { SessionRecap } from 'components/sections/analytics/session-hits/recap';
import { MachineContext } from 'contexts/machine.context';
import { useContext, useEffect, useState } from 'react';
import { HittersService } from 'services/hitters.service';
import { useAuthStore } from 'stores/use-auth-store';
import useHittersStore from 'stores/use-hitters-store';

export const PitchListHittingResultsNew = () => {
  const sessionStart = useAuthStore((s) => s.sessionStart);

  const activeHitter = useHittersStore((s) => s.activeHitter);

  const { machine } = useContext(MachineContext);

  const hitterID = PitchListHelper.getSafeHitterID(activeHitter);

  const [sessionID, setSessionID] = useState('');

  useEffect(() => {
    if (!sessionStart) {
      return;
    }

    let cancelled = false;

    HittersService.getInstance()
      .getLatestSessionByHitterID({
        newerThan: sessionStart.toISOString(),
        hitterID: activeHitter?._id ?? null,
      })
      .then((session) => {
        if (!cancelled) {
          setSessionID(session?._id ?? '');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [sessionStart, activeHitter?._id]);

  return (
    <ErrorBoundary identifier="PitchListHittingResults">
      <SessionRecap
        sessionID={sessionID}
        hitterID={hitterID}
        machineID={machine?.machineID}
        header={null}
      />
    </ErrorBoundary>
  );
};
